import './component.scss'
import $ from 'jquery'
import 'slick-carousel'
import './images/photo_icon.svg'
import 'Components/basics/truncate_text/component'

const SLICK_IMAGES_TARGET_SELECTOR = '.js-slick-images-target'
const SLICK_COMMENTS_TARGET_SELECTOR = '.js-slick-comments-target'

$(() => {
  const $imagesTarget = $(SLICK_IMAGES_TARGET_SELECTOR)
  const slickImagesOptions = {
    speed: 800,
    lazyLoad: 'progressive',
    infinite: false
  }

  slickImagesOptions.asNavFor = SLICK_COMMENTS_TARGET_SELECTOR

  $(SLICK_COMMENTS_TARGET_SELECTOR).slick({
    speed: 800,
    asNavFor: SLICK_IMAGES_TARGET_SELECTOR,
    arrows: false,
    draggable: false,
    infinite: false
  })

  $(SLICK_IMAGES_TARGET_SELECTOR).slick(slickImagesOptions)
})
